import React, { useState } from 'react'
import { maleAvatar } from '../../../assets'
import useFetchUserByToken from '../../../hooks/useFetchUserByToken'
import { FormChangePassword } from '../../'
import Modal from 'react-bootstrap/Modal';

export default function Navbar() {

    const user = useFetchUserByToken()

    const [showChangePassword, setshowChangePassword] = useState(false)

    const handleAfterSubmit = () => {
        setshowChangePassword(false)
        setTimeout(() => {
            window.location.reload()
            localStorage.clear()
        }, 3000);
    }

    // console.log(user.user.id)

    return (
        <>
            <header className="navbar navbar-expand-md navbar-light d-none d-lg-flex d-print-none">
                <div className="container-xl">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="navbar-nav flex-row order-md-last">
                        <div className="d-none d-md-flex">
                        </div>

                        {/* <div className="nav-item dropdown">
                            <span type="button" className="nav-link d-flex lh-1 text-reset p-0">
                                <img className="avatar avatar-sm" src={maleAvatar} alt='maleAvatar' />
                                <div className="d-none d-xl-block ps-2">
                                    <div>{user.user.firstName} {user.user.lastName}</div>
                                    <div className="mt-1 small text-muted">{user.user.email}</div>
                                </div>
                            </span>
                        </div> */}

                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
                                <img className="avatar avatar-sm" src={maleAvatar} alt='maleAvatar' />
                                <div className="d-none d-xl-block ps-2">
                                    <div>{user.user.firstName} {user.user.lastName}</div>
                                    <div className="mt-1 small text-muted">{user.user.email}</div>
                                </div>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                <span className="dropdown-item" onClick={() => setshowChangePassword(true)}>Change Password</span>
                            </div>
                        </div>
                    </div>
                    <div className="collapse navbar-collapse" id="navbar-menu">
                    </div>
                </div>
            </header>

            <Modal
                show={showChangePassword}
                size='sm'
                onHide={() => setshowChangePassword(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <Modal.Title>
                        <h3 className='mb-3'>Form Ubah Password</h3>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <FormChangePassword
                        close={() => handleAfterSubmit()}
                        userId={user?.user?.id}
                    />
                </Modal.Body>
            </Modal>

        </>
    )
}
